import { createApp } from 'vue'
import ToastService from 'primevue/toastservice'
import { createPinia } from 'pinia'
import PrimeVue from 'primevue/config'
import App from './App.vue'
import router from './router'
import { i18n } from './i18n'
import 'primeicons/primeicons.css'
import '@fontsource/inter'
import '@fontsource/roboto'
import { customPreset } from './style-preset'
import 'jetbrains-mono'
import '@/assets/styles.css'
import Tooltip from 'primevue/tooltip'
import '@/directives/tooltipPatch'

const app = createApp(App)
const primeVueParams = {
  theme: {
    preset: customPreset,
    options: {
      darkModeSelector: '.p-dark',
      cssLayer: {
        name: 'primevue',
        order: 'base, primevue',
      },
    },
  },
}

app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(ToastService)
app.use(PrimeVue, primeVueParams)
app.mount('#app')
app.directive('tooltip', Tooltip)
